export const SOFTWARE = {
  GET: {
    INITIATE: 'SOFTWARE_GET_INITIATE',
    SUCCESS: 'SOFTWARE_GET_SUCCESS',
    ERROR: 'SOFTWARE_GET_ERROR',
  },
  DATA: {
    INITIATE: 'SOFTWARE_DATA_INITIATE',
    SUCCESS: 'SOFTWARE_DATA_SUCCESS',
    ERROR: 'SOFTWARE_DATA_ERROR',
  },
  VERSION: {
    INITIATE: 'SOFTWARE_VERSION_INITIATE',
    SUCCESS: 'SOFTWARE_VERSION_SUCCESS',
    ERROR: 'SOFTWARE_VERSION_ERROR',
  },
  VERSION_DATA: {
    INITIATE: 'SOFTWARE_VERSION_DATA_INITIATE',
    SUCCESS: 'SOFTWARE_VERSION_DATA_SUCCESS',
    ERROR: 'SOFTWARE_VERSION_DATA_ERROR',
  },
  SUBMODULE: {
    INITIATE: 'SOFTWARE_SUBMODULE_INITIATE',
    SUCCESS: 'SOFTWARE_SUBMODULE_SUCCESS',
    ERROR: 'SOFTWARE_SUBMODULE_ERROR',
  },
  SUBMODULE_VERSION: {
    INITIATE: 'SOFTWARE_SUBMODULE_VERSION_INITIATE',
    SUCCESS: 'SOFTWARE_SUBMODULE_VERSION_SUCCESS',
    ERROR: 'SOFTWARE_SUBMODULE_VERSION_ERROR',
  },
  SOFTWARE_SETTINGS: {
    INITIATE: 'SOFTWARE_SETTINGS_INITIATE',
    SUCCESS: 'SOFTWARE_SETTINGS_SUCCESS',
    ERROR: 'SOFTWARE_SETTINGS_ERROR',
  },
  SUBMODULE_DATA: {
    INITIATE: 'SOFTWARE_SUBMODULE_DATA_INITIATE',
    SUCCESS: 'SOFTWARE_SUBMODULE_DATA_SUCCESS',
    ERROR: 'SOFTWARE_SUBMODULE_DATA_ERROR',
  },
  SUBMODULE_LIST: {
    INITIATE: 'SOFTWARE_SUBMODULE_LIST_INITIATE',
    SUCCESS: 'SOFTWARE_SUBMODULE_LIST_SUCCESS',
    ERROR: 'SOFTWARE_SUBMODULE_LIST_ERROR',
  },
  DOWNLOAD_VERSION: {
    INITIATE: 'SOFTWARE_DOWNLOAD_VERSION_INITIATE',
    SUCCESS: 'SOFTWARE_DOWNLOAD_VERSION_SUCCESS',
    ERROR: 'SOFTWARE_DOWNLOAD_VERSION_ERROR',
  },
  PLATFORMS: {
    INITIATE: 'GET_SOFTWARE_PLATFORM_REQUEST_INITIATE',
    SUCCESS: 'GET_SOFTWARE_PLATFORM_SUCCESS',
    ERROR: 'GET_SOFTWARE_PLATFORM_ERROR',
  },
};

export const RE_SELLER = {
  GET: {
    INITIATE: 'RE_SELLER_GET_INITIATE',
    SUCCESS: 'RE_SELLER_GET_SUCCESS',
    ERROR: 'RE_SELLER_GET_ERROR',
  },
  DATA: {
    INITIATE: 'RE_SELLER_DATA_REQUEST_INITIATE',
    SUCCESS: 'GET_RE_SELLER_DATA_SUCCESS',
    ERROR: 'GET_RE_SELLER_DATA_ERROR',
  },
};

export const CLIENT = {
  GET: {
    INITIATE: 'CLIENT_GET_INITIATE',
    SUCCESS: 'CLIENT_GET_SUCCESS',
    ERROR: 'CLIENT_GET_ERROR',
  },
  DATA: {
    INITIATE: 'GET_CLIENT_DATA_REQUEST_INITIATE',
    SUCCESS: 'GET_CLIENT_DATA_SUCCESS',
    ERROR: 'GET_CLIENT_DATA_ERROR',
  },
  SOFTWARES: {
    INITIATE: 'GET_CLIENT_SOFTWARE_REQUEST_INITIATE',
    SUCCESS: 'GET_CLIENT_SOFTWARE_SUCCESS',
    ERROR: 'GET_CLIENT_SOFTWARE_ERROR',
  },
  SOFTWARE_SUBMODULES: {
    INITIATE: 'GET_CLIENT_SOFTWARE_SUBMODULE_REQUEST_INITIATE',
    SUCCESS: 'GET_CLIENT_SOFTWARE_SUBMODULE_SUCCESS',
    ERROR: 'GET_CLIENT_SOFTWARE_SUBMODULE_ERROR',
  },
  SOFTWARES_INSTALLED_LIST: {
    INITIATE: 'GET_CLIENT_SOFTWARE_REQUEST_INITIATE',
    SUCCESS: 'GET_CLIENT_SOFTWARE_SUCCESS',
    ERROR: 'GET_CLIENT_SOFTWARE_ERROR',
  },
  WHITE_IP: {
    INITIATE: 'CLIENT_WHITE_IP_INITIATE',
    SUCCESS: 'CLIENT_WHITE_IP_SUCCESS',
    ERROR: 'CLIENT_WHITE_IP_ERROR',
  },
  WHITE_IP_LIST: {
    INITIATE: 'CLIENT_WHITE_IP_LIST_INITIATE',
    SUCCESS: 'CLIENT_WHITE_IP_LIST_SUCCESS',
    ERROR: 'CLIENT_WHITE_IP_LIST_ERROR',
  },
  USER_LIST: {
    INITIATE: 'CLIENT_USER_LIST_INITIATE',
    SUCCESS: 'CLIENT_USER_LIST_SUCCESS',
    ERROR: 'CLIENT_USER_LIST_ERROR',
  },
};

export const CLOUD_CLIENT = {
  GET: {
    INITIATE: 'CLOUD_CLIENT_GET_INITIATE',
    SUCCESS: 'CLOUD_CLIENT_GET_SUCCESS',
    ERROR: 'CLOUD_CLIENT_GET_ERROR',
  },
  DATA: {
    INITIATE: 'GET_CLOUD_CLIENT_DATA_REQUEST_INITIATE',
    SUCCESS: 'GET_CLOUD_CLIENT_DATA_SUCCESS',
    ERROR: 'GET_CLOUD_CLIENT_DATA_ERROR',
  },
  SOFTWARES: {
    INITIATE: 'GET_CLOUD_CLIENT_SOFTWARE_REQUEST_INITIATE',
    SUCCESS: 'GET_CLOUD_CLIENT_SOFTWARE_SUCCESS',
    ERROR: 'GET_CLOUD_CLIENT_SOFTWARE_ERROR',
  },
  SOFTWARE_SUBMODULES: {
    INITIATE: 'GET_CLOUD_CLIENT_SOFTWARE_SUBMODULE_REQUEST_INITIATE',
    SUCCESS: 'GET_CLOUD_CLIENT_SOFTWARE_SUBMODULE_SUCCESS',
    ERROR: 'GET_CLOUD_CLIENT_SOFTWARE_SUBMODULE_ERROR',
  },
  SOFTWARES_LIST: {
    INITIATE: 'GET_CLOUD_CLIENT_SOFTWARE_REQUEST_INITIATE',
    SUCCESS: 'GET_CLOUD_CLIENT_SOFTWARE_SUCCESS',
    ERROR: 'GET_CLOUD_CLIENT_SOFTWARE_ERROR',
  },
  WHITE_IP: {
    INITIATE: 'CLOUD_CLIENT_WHITE_IP_INITIATE',
    SUCCESS: 'CLOUD_CLIENT_WHITE_IP_SUCCESS',
    ERROR: 'CLOUD_CLIENT_WHITE_IP_ERROR',
  },
  WHITE_IP_LIST: {
    INITIATE: 'CLOUD_CLIENT_WHITE_IP_LIST_INITIATE',
    SUCCESS: 'CLOUD_CLIENT_WHITE_IP_LIST_SUCCESS',
    ERROR: 'CLOUD_CLIENT_WHITE_IP_LIST_ERROR',
  },
  USER_LIST: {
    INITIATE: 'CLOUD_CLIENT_USER_LIST_INITIATE',
    SUCCESS: 'CLOUD_CLIENT_USER_LIST_SUCCESS',
    ERROR: 'CLOUD_CLIENT_USER_LIST_ERROR',
  },
};

export const CLIENT_SOFTWARE = {
  GET: {
    INITIATE: 'GET_CLIENT_SOFTWARE_DATA_REQUEST_INITIATE',
    SUCCESS: 'GET_CLIENT_SOFTWARE_DATA_SUCCESS',
    ERROR: 'GET_CLIENT_SOFTWARE_DATA_ERROR',
  },
  DATA: {
    INITIATE: 'SOFTWARE_DATA_INITIATE',
    SUCCESS: 'SOFTWARE_DATA_SUCCESS',
    ERROR: 'SOFTWARE_DATA_ERROR',
  },
};

export const CLIENT_DOMAIN = {
  GET: {
    INITIATE: 'GET_CLIENT_DOMAIN_DATA_REQUEST_INITIATE',
    SUCCESS: 'GET_CLIENT_DOMAIN_DATA_SUCCESS',
    ERROR: 'GET_CLIENT_DOMAIN_DATA_ERROR',
  },
  DATA: {
    INITIATE: 'DOMAIN_DATA_INITIATE',
    SUCCESS: 'DOMAIN_DATA_SUCCESS',
    ERROR: 'DOMAIN_DATA_ERROR',
  },
};

export const DOWNLOAD_SOFTWARE = {
  GET: {
    INITIATE: 'GET_DOWNLOAD_SOFTWARE_DATA_REQUEST_INITIATE',
    SUCCESS: 'GET_DOWNLOAD_SOFTWARE_DATA_SUCCESS',
    ERROR: 'GET_DOWNLOAD_SOFTWARE_DATA_ERROR',
  },
};
export const PUBLIC_CLIENT_SOFTWARE = {
  GET: {
    INITIATE: 'GET_PUBLIC_CLIENT_SOFTWARE_DATA_REQUEST_INITIATE',
    SUCCESS: 'GET_PUBLIC_CLIENT_SOFTWARE_DATA_SUCCESS',
    ERROR: 'GET_PUBLIC_CLIENT_SOFTWARE_DATA_ERROR',
  },
};

export const USER = {
  ROLE: {
    INITIATE: 'GET_ROLE_LIST_REQUEST_INITIATE',
    SUCCESS: 'GET_ROLE_LIST_SUCCESS',
    ERROR: 'GET_ROLE_LIST_ERROR',
  },
  ROLE_LIST: {
    INITIATE: 'GET_USER_ROLE_LIST_REQUEST_INITIATE',
    SUCCESS: 'GET_USER_ROLE_LIST_REQUEST_SUCCESS',
    ERROR: 'GET_USER_ROLE_LIST_REQUEST_ERROR',
  },
  USER_TOKEN: {
    INITIATE: 'GET_USER_TOKEN_REQUEST_INITIATE',
    SUCCESS: 'GET_USER_TOKEN_REQUEST_SUCCESS',
    ERROR: 'GET_USER_TOKEN_REQUEST_ERROR',
  },
  DATA: {
    INITIATE: 'GET_USER_DATA_REQUEST_INITIATE',
    SUCCESS: 'GET_USER_DATA_SUCCESS',
    ERROR: 'GET_USER_DATA_ERROR',
  },

  GET: {
    INITIATE: 'GET_USER_LIST_REQUEST_INITIATE',
    SUCCESS: 'GET_USER_LIST_SUCCESS',
    ERROR: 'GET_USER_LIST_ERROR',
  },
  SOFTWARES: {
    INITIATE: 'GET_USER_SOFTWARE_REQUEST_INITIATE',
    SUCCESS: 'GET_USER_SOFTWARE_SUCCESS',
    ERROR: 'GET_USER_SOFTWARE_ERROR',
  },
  SOFTWARE_SUBMODULES: {
    INITIATE: 'GET_USER_SOFTWARE_SUBMODULE_REQUEST_INITIATE',
    SUCCESS: 'GET_USER_SOFTWARE_SUBMODULE_SUCCESS',
    ERROR: 'GET_USER_SOFTWARE_SUBMODULE_ERROR',
  },
  SOFTWARES_INSTALLED_LIST: {
    INITIATE: 'GET_USER_SOFTWARE_REQUEST_INITIATE',
    SUCCESS: 'GET_USER_SOFTWARE_SUCCESS',
    ERROR: 'GET_USER_SOFTWARE_ERROR',
  },
};

export const DASHBOARD = {
  USER: {
    INITIATE: 'GET_USER_DASHBOARD_REQUEST_INITIATE',
    SUCCESS: 'GET_USER_DASHBOARD_SUCCESS',
    ERROR: 'GET_USER_DASHBOARD_ERROR',
  },
};

export const MAIL = {
  DATA: {
    INITIATE: 'GET_MAIL_REQUEST_INITIATE',
    SUCCESS: 'GET_MAIL_SUCCESS',
    ERROR: 'GET_MAIL_ERROR',
  },
};

export const PLATFORM = {
  GET: {
    INITIATE: 'PLATFORM_GET_INITIATE',
    SUCCESS: 'PLATFORM_GET_SUCCESS',
    ERROR: 'PLATFORM_GET_ERROR',
  },
  DATA: {
    INITIATE: 'PLATFORM_DATA_INITIATE',
    SUCCESS: 'PLATFORM_DATA_SUCCESS',
    ERROR: 'PLATFORM_DATA_ERROR',
  },
};

export const PLATFORM_ALERT = {
  GET: {
    INITIATE: 'PLATFORM_ALERT_GET_INITIATE',
    SUCCESS: 'PLATFORM_ALERT_GET_SUCCESS',
    ERROR: 'PLATFORM_ALERT_GET_ERROR',
  },
  DATA: {
    INITIATE: 'PLATFORM_ALERT_DATA_INITIATE',
    SUCCESS: 'PLATFORM_ALERT_DATA_SUCCESS',
    ERROR: 'PLATFORM_ALERT_DATA_ERROR',
  },
};

export const SYSTEM_EVENT = {
  DATA: {
    INITIATE: 'SYSTEM_EVENT_DATA_INITIATE',
    SUCCESS: 'SYSTEM_EVENT_DATA_SUCCESS',
    ERROR: 'SYSTEM_EVENT_DATA_ERROR',
  },
};
export const CRASH_LOG = {
  DATA: {
    INITIATE: 'CRASH_LOG_DATA_INITIATE',
    SUCCESS: 'CRASH_LOG_DATA_SUCCESS',
    ERROR: 'CRASH_LOG_DATA_ERROR',
  },
};

export const SYSLOG_SETTING = {
  GET: {
    INITIATE: 'SYSLOG_SETTING_GET_INITIATE',
    SUCCESS: 'SYSLOG_SETTING_GET_SUCCESS',
    ERROR: 'SYSLOG_SETTING_GET_ERROR',
  },
  DATA: {
    INITIATE: 'SYSLOG_SETTING_DATA_INITIATE',
    SUCCESS: 'SYSLOG_SETTING_DATA_SUCCESS',
    ERROR: 'SYSLOG_SETTING_DATA_ERROR',
  },
};

export const ML_SCAN = {
  GET: {
    INITIATE: 'GET_ML_SCAN_DATA_REQUEST_INITIATE',
    SUCCESS: 'GET_ML_SCAN_DATA_SUCCESS',
    ERROR: 'GET_ML_SCAN_DATA_ERROR',
  },
};

export const INT_MODEL = {
  GET: {
    INITIATE: 'GET_INT_MODEL_DATA_REQUEST_INITIATE',
    SUCCESS: 'GET_INT_MODEL_DATA_SUCCESS',
    ERROR: 'GET_INT_MODEL_DATA_ERROR',
  },
};

export const SHARED_AUTH_URLS = {
  GET: {
    INITIATE: 'GET_SHARED_AUTH_URLS_REQUEST_INITIATE',
    SUCCESS: 'GET_SHARED_AUTH_URLS_SUCCESS',
    ERROR: 'GET_SHARED_AUTH_URLS_ERROR',
  },
};

export const ACTIVE_SESSIONS = {
  GET: {
    INITIATE: 'ACTIVE_SESSIONS_REQUEST_INITIATE',
    SUCCESS: 'ACTIVE_SESSIONS_SUCCESS',
    ERROR: 'ACTIVE_SESSIONS_ERROR',
  },
};

export const SMTP_SETTINGS = {
  GET: {
    INITIATE: 'GET_SMTP_SETTINGS',
    SUCCESS: 'GET_SMTP_SETTINGS_DATA_SUCCESS',
    ERROR: 'GET_SMTP_SETTINGS_DATA_ERROR',
  },
  VERIFY: {
    INITIATE: 'SMTP_SETTINGS_VERIFY_INITIATE',
    SUCCESS: 'SMTP_SETTINGS_VERIFY_SUCCESS',
    ERROR: 'SMTP_SETTINGS_VERIFY_ERROR',
  },
};

export const SLACK_SETTINGS = {

  GET: {
    INITIATE: 'GET_SLACK_SETTINGS',
    SUCCESS: 'GET_SLACK_SETTINGS_DATA_SUCCESS',
    ERROR: 'GET_SLACK_SETTINGS_DATA_ERROR',
  },

  POST: {
    INITIATE: 'SAVE_SLACK_SETTINGS',
    SUCCESS: 'SAVE_SLACK_SETTINGS_DATA_SUCCESS',
    ERROR: 'SAVE_SLACK_SETTINGS_DATA_ERROR',
  },

};
